import { deleteDoc, doc } from 'firebase/firestore';
import { deleteObject, ref as storageRef } from 'firebase/storage';
import { db, storage } from '../../lib/firebase';

/**
 * ストリートビュー机上調査の post を物理削除する (`usePostsModeration.ts` の `deletePost` と
 * 同じ方式: firestore.rules の `allow delete: if isDistrictAdmin(districtId)` に委ね、
 * callable は用意しない)。
 *
 * Google 由来の SV post は写真を Storage に保存しない (docs/25、Street View 静止画は都度取得・
 * 非永続化) ため Firestore ドキュメント削除のみで完結する。登録済み 360度写真 (docs/27) は
 * `photoPaths` を渡すと Storage の原本・サムネも best-effort で削除する (失敗は warn のみ)。
 */
export async function deleteStreetSurveyPost(
  districtId: string,
  postId: string,
  photoPaths: (string | null | undefined)[] = [],
): Promise<void> {
  const ref = doc(db, 'districts', districtId, 'posts', postId);
  await deleteDoc(ref);
  await Promise.all(
    photoPaths
      .filter((p): p is string => !!p)
      .map(async (p) => {
        try {
          await deleteObject(storageRef(storage, p));
        } catch (e) {
          console.warn(`deleteStreetSurveyPost: Storage 削除に失敗 ${p}`, e);
        }
      }),
  );
}
